$(function () {
  //////ナビゲーション
  $(".menu_trigger").on("click", function () {
    $(this).toggleClass("active");
    $(".nav_contents").slideToggle();
  });

  $(".nav_contents a").on("click", function (event) {
    if (window.innerWidth <= 1200) {
      event.preventDefault();
      var target = $(this).attr("href");
      $(".menu_trigger").click();
      setTimeout(function () {
        window.location.href = target;
      }, 300);
    }
  });

  $(window).on("resize", function () {
    if ($(".nav_contents").css("display") === "none") {
      $(".nav_contents").attr("style", "");
    }
  });

  //////ナビゲーション(sub pc)
  $(document).ready(function () {
    if (window.matchMedia("(min-width: 1200px)").matches) {
      $(".nav_item li").hover(function () {
        $(this).children(".nav_item_sub__inner").stop().fadeToggle("fast");
      });
    } else {
      $(".nav_item li").click(function () {
        $(this)
          .children(".nav_item_sub__inner")
          .stop()
          .slideToggle(function () {
            if ($(this).is(":visible")) {
              $(this).parent("li").addClass("open");
            } else {
              $(this).parent("li").removeClass("open");
            }
          });

        $(".nav_item li")
          .not($(this))
          .children(".nav_item_sub__inner")
          .slideUp()
          .parent("li")
          .removeClass("open");
      });
    }
  });
  //////ヘッダー変更
  $(window).scroll(function () {
    if ($(window).scrollTop() > 50) {
      $("header").addClass("header_fixed");
    } else {
      $("header").removeClass("header_fixed");
    }
  });
  //////ページトップ
  var topBtn = $("#page-top");
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 650) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      1000
    );
    return false;
  });
  //////スムーススクロール
  $('a[href^="#"]').click(function () {
    var speed = 1500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;

    // ヘッダーの高さを取得して、その分だけスクロール位置を調整
    var headerHeight = $("header").outerHeight(); // ヘッダーのセレクタを指定
    var adjustedPosition = position - headerHeight;

    $("html, body").animate({ scrollTop: adjustedPosition }, speed, "swing");
    return false;
  });

  // 表示させるwidthを指定
  var ua = navigator.userAgent;
  var viewport = document.querySelector("meta[name=viewport]");
  if (
    ua.indexOf("iPhone") > 0 ||
    ua.indexOf("iPod") > 0 ||
    (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0) ||
    ua.indexOf("iPad") > 0 ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) || // iPadデバイスを追加
    (ua.indexOf("Android") > 0 && ua.indexOf("Tablet") > 0) // Androidタブレットデバイスを追加
  ) {
    viewport.setAttribute("content", "width=device-width,initial-scale=1");
  } else {
    viewport.setAttribute("content", "width=1550");
  }
});

//////アニメーション
$(window).scroll(function () {
  $(".js_anime").each(function () {
    var pos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > pos - windowHeight + 100) {
      $(this).addClass("scroll");
    }
  });
});

//js-scroll
var EffectH = 50;
jQuery(window).on("scroll load", function () {
  var scTop = $(this).scrollTop();
  var scBottom = scTop + $(this).height();
  var effectPos = scBottom - EffectH;
  jQuery(".js-scroll").each(function () {
    var thisPos = $(this).offset().top;
    if (thisPos < effectPos) {
      $.when(jQuery(this).addClass("show")).done(function () {
        jQuery(this)
          .delay(250)
          .queue(function () {
            jQuery(this).addClass("done");
          });
      });
    }
  });
});
//vhの取得
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}
setHeight();
window.addEventListener("resize", setHeight);

// テキストアニメーション
function EachTextAnimeControl() {
  $(".text_anime").each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
  });
}
$(window).scroll(function () {
  EachTextAnimeControl();
});

$(window).on("load", function () {
  var element = $(".text_anime");
  element.each(function () {
    var text = $(this).text();
    var textbox = "";
    text.split("").forEach(function (t, i) {
      if (t !== " ") {
        if (i < 10) {
          textbox +=
            '<span style="animation-delay:.' + i + 's;">' + t + "</span>";
        } else {
          var n = i / 10;
          textbox +=
            '<span style="animation-delay:' + n + 's;">' + t + "</span>";
        }
      } else {
        textbox += t;
      }
    });
    $(this).html(textbox);
  });

  EachTextAnimeControl();
});
// ストーリーナビ
$(function () {
  $(window).on("load scroll resize", function () {
    var wh = $(window).height();
    var st = $(window).scrollTop();

    $(".swich_bg").each(function (i, elem) {
      var one = $(elem).offset().top;
      var showClass = "bg_show";
      if (st >= one - wh + wh / 2) {
        $(elem).addClass(showClass);
      } else {
        $(elem).removeClass(showClass);
      }
    });

    $(".scroll-point").each(function (i) {
      var tg = $(this).offset().top;
      var id = $(this).attr("id");
      var showClass = "current";
      if (st > tg - wh + wh / 2) {
        $(".p-sideNav_link").removeClass(showClass);
        var link = $(".p-sideNav_link[href*='" + id + "']");
        $(link).addClass(showClass);
      }
    });

    var $intro = $("#intro");
    if ($intro.length) {
      // Check if the element exists
      var introTop = $intro.offset().top;
      var navClass = "active";

      if (
        st >= introTop - wh + wh / 2 &&
        st < introTop + $intro.height() - wh / 2
      ) {
        $(".p-sideNav").addClass(navClass);
      } else {
        $(".p-sideNav").removeClass(navClass);
      }
    }

    var $colBtm = $("#col_btm");
    if ($colBtm.length) {
      // Check if the element exists
      var colBtmTop = $colBtm.offset().top;
      var offset = 100; // Adjust this value as needed
      if (st >= colBtmTop - wh + wh / 2 - offset) {
        $(".p-sideNav").hide(); // Hide .p-sideNav
      } else {
        $(".p-sideNav").show(); // Show .p-sideNav
      }
    }
  });
});
